<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
  .signUp{
    /*width: 1200px;*/
    /*margin: 0 auto;*/
    background: url("../assets/img/bg.png")no-repeat;
    background-position-y:top;
    width: 100%;
    overflow: hidden;
    background-size: cover;
  }
  .signUp .nav{
    background:url('../assets/img/navbg.png')no-repeat;
    width: 1530px;
    height: 110px;
    margin: 0 auto;
    margin-top: 60px;
  }
  .signUp .nav img{
    float: left;
    margin-left: 160px;
    margin-top: 35px;
  }
  .signUp .nav ul{
    float: left;
    overflow: hidden;
    margin-left: 50px;
  }
  .signUp .nav ul li{
    float: left;
    /*margin-right: 40px;*/
    width: 120px;
    text-align: center;
    line-height: 110px;
    color: #ebbfbf;
    font-size: 16px;
    font-weight: 900;
    cursor: pointer;
    position: relative;
  }
  .signUp .nav ul li:hover{
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 21px;
  }
  .signUp .nav ul li span{
    position: absolute;
    left: 0;
    bottom: -25px;
    text-align: center;
    width: 100%;
    font-weight: 100;
  }
  .signUp .nav .btn{
    float: right;
    margin-right: 150px;
    width: 185px;
    cursor: pointer;
    margin-top: 30px;
    height: 62px;
    background: url("../assets/img/btn.png")no-repeat;
  }
  .signUp .content {
    width: 1200px;
    margin: 0 auto;
    /*margin-bottom: 195px;*/
    overflow: hidden;
  }
  .signUp .content .title{
    margin-top: 100px;
    color: #ffffff;
    font-size: 36px;
    font-weight: 900;
    margin-bottom: 30px;
  }
  .signUp .content .title img{
    margin-right: 15px;
  }
  .signUp .content .text{
    width: 940px;
    height: 580px;
    margin: 0 auto;
    overflow: hidden;
    padding-bottom: 100px;
    border-bottom:1px solid #2c2c2c;
    box-sizing: content-box;
  }
  .signUp .content .text .myleft{
    width: 440px;
    height: 587px;
    float: left;
    background: url("../assets/img/upload.png")no-repeat;
    position: relative;
  }
  .signUp .content .text .myleft img{
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .signUp .content .text .myleft .sc{
    position: absolute;
    width: 100%;
    height:100%;
    left: 0;
    /*margin-top: 140px;*/
    /* background: red; */
    overflow: hidden;
    /*border: 2px solid #f2f6fc;*/
    text-align: center;
    line-height: 40px;
    color: #fff;
    /*margin-left: 10px;*/
    z-index: 10;
  }
  .signUp .content .text .myleft .sc .fl{
    display: inline-block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
  }
  .signUp .content .text .right{
    float: right;
    width: 460px;
    /*margin-right: 130px;*/
  }
  .signUp .content .text .right ul li{
    width: 100%;
    margin-bottom: 23px;
  }
  .signUp .content .text .right ul li select{
    height: 60px;
    width: 460px;
    background-color: #2a2a2a;
    color: #949494;
    font-size: 16px;
    text-indent: 1em;
  }
  .signUp .content .text .right ul li input{
    width: 100%;
    color: #949494;
    font-size: 16px;
    text-indent: 1em;
    height: 60px;
    background-color: #2a2a2a;
  }
  .signUp .content .role{
    background: url("../assets/img/roleImg.png")no-repeat;
    width: 812px;
    height: 562px;
    margin: 0 auto;
    margin-top: 100px;
    position: relative;
  }
  .signUp .content .role .img{
    position: absolute;
    width: 118px;
    height: 118px;
    top: 300px;
    /*background: red;*/
    border-radius: 5px;
  }
  .signUp .content .role .img1 {
    top: 356px;
    left: 5px;
   }
  .signUp .content .role .img2 {
    top: 439px;
    right: 345px;
  }
  .signUp .content .role .img3 {
    top: 356px;
    right: 5px;
  }
  .signUp .content .btnUpBOx{
    width: 800px;
    margin: 0 auto;
    border-top: 1px solid #2c2c2c;
    padding-top: 100px;
    margin-top: 100px;
  }
  .signUp .content .btnUp {
    /*background: url("../assets/img/btnUp.png")no-repeat;*/
    width: 308px;
    height: 68px;
    margin: 0 auto;
    cursor: pointer;
    text-align: center;
    border: 3px solid #333333;
    background-color: #c21415;
  }
  .signUp .content .btnUp p{
    color: #ffffff;
    font-size: 20px;
  }
  .signUp .roleBox{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    z-index: 99;
  }
  .signUp .rolebg{
    top: 10%;
    position: absolute;
    background: url("../assets/img/roleBox.png")no-repeat;
    width: 1140px;
    height: 700px;
    left: 50%;
    margin-left: -580px;
  }
  .signUp .gb{
    position: absolute;
    width: 60px;
    height: 60px;
    /*background: red;*/
    right: 0;
    cursor: pointer;
  }
  .signUp .rolebg ul{
    margin-top: 235px;
    margin-left: 16px;
    overflow: hidden;
  }
  .signUp .rolebg ul li{
    float: left;
    margin-right: 11px;
    margin-bottom: 40px;
  }
  .signUp .rolebg ul li.on img{
    /*border: 4px solid #db0e09;*/
  }
  .signUp .rolebg ul li.on p{
    color: #db0e09;
    font-weight: 900;
  }
  .signUp .rolebg ul li img{
    width: 80px;
    height: 80px;
    /*border: 4px solid #333;*/
    cursor: pointer;
  }
  .signUp .rolebg ul li p{
    margin-top: 8px;
    font-size: 14px;
    color: #ffffff;
  }
  .signUp .roleBtn{
    position: absolute;
    background: url("../assets/img/roleBtn.png")no-repeat;
    width: 300px;
    height: 60px;
    top: 85%;
    left: 50%;
    margin-left: -150px;
    cursor: pointer;
  }
  .signUp .content .mp1{
    width: 580px;
    float: left;
  }
  .signUp .content .mp2{
    width: 580px;
    float: right;
  }
  .signUp .content .map img{
    width: 100%;
  }
  .signUp .content .map p {
    color: #ffffff;
    margin: 10px 0;
  }
</style>
<template>
  <div class="signUp">
    <myhead></myhead>
    <nav class="nav">
      <img src="../assets/img/logo.png" alt=""/>
      <ul>
        <li @click="urlFun('/home')"> 首页 <span>Home</span></li>
        <li @click="urlFun('/news')">新闻<span> News</span></li>
        <li @click="urlFun('/rules')">规则<span> Rule</span></li>
        <li @click="urlFun('/match')">赛程<span>Schedule</span></li>
        <!--<li @click="urlFun('/videoList')">视频<span>Video</span></li>-->
        <li @click="urlFun('/stadium')">场馆<span>Venue</span></li>
        <li @click="urlFun('/live')">直播<span> Live</span></li>
      </ul>
      <div class="btn" @click="urlFun('/signUp')"></div>
    </nav>
    <div class="content">
      <div class="title"><img src="../assets/img/title.png" alt=""/>报名</div>
      <div class="text">
        <div class="myleft" >
          <img :src="fimg" alt=""/>
          <a href="" class="sc"><input class="fl" type="file" ref="file" accept="image/*" @change="chang()"/></a>
        </div>
        <div class="right">
          <ul>
            <li><input type="text" placeholder="请填写您的姓名(Name)"  v-model="name"/></li>
            <li><input type="text" placeholder="请填写您的手机号(phone number)" v-model="phone"/></li>
            <li><input type="text" placeholder="请填写您的身份证号(Passport number)" v-model="identityCard"/></li>
            <li>
              <select @change="nationFun(nationID)" v-model="nationID">
                <option v-for="(key,index) in nationData" :value="key.id">{{key.name}}</option>
              </select>
            </li>
            <li><input type="text" placeholder="请填写Steam街霸5(Steam ID for《Street Fighter V》)" v-model="SteamId"/></li>
            <li><input type="text" placeholder="请填写您的邮箱(E-mail address)" v-model="email"/></li>
            <li><input type="text" placeholder="请填写您的QQ号(QQ number or skype ID)" v-model="QQ"/></li>
          </ul>
        </div>
      </div>
      <div class="role">
        <p style="position: absolute;text-align: center;width: 100%;margin-top: 76px;color: #fff;">please select three common characters</p>
        <img class="img img1" :src="role1.img2" alt="" @click="imgFun()"/>
        <img class="img img2" :src="role2.img2" alt="" @click="imgFun()"/>
        <img class="img img3" :src="role3.img2" alt="" @click="imgFun()"/>
      </div>
      <div class="btnUpBOx">
        <div class="btnUp" @click="subbtnUp()">
          <p style="margin-top: 10px">提交个人信息</p>
          <p>Upload</p>
        </div>
      </div>
      <div class="title"><img src="../assets/img/title.png" alt=""/>比赛赛程/Competition schedule</div>
      <div style="margin-top: -120px;width: 1200px;">
        <img style="width: 830px;margin: 0 auto;display: inherit;" src="../assets/img/matchImg2.png" alt=""/>
      </div>
      <div style="overflow: hidden">
        <div class="title"><img src="../assets/img/title.png" alt=""/>比赛场馆/Competition venues</div>
        <div class="map mp1">
          <iframe src="http://www.google.cn/maps/embed?pb=!1m18!1m12!1m3!1d3408.4625689012537!2d121.48284531565263!3d31.31859598143671!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35b2724e8505a4e9%3A0x26fa00917fbd1e09!2z5LiK5rW35biC5a6d5bGx5Yy65LqU6KeS5Zy66YC45LuZ6LevMTMyOOWPtyDpgq7mlL_nvJbnoIE6IDIwMDA2NQ!5e0!3m2!1szh-CN!2scn!4v1566195582192!5m2!1szh-CN!2scn" width="580" height="440" frameborder="0" style="border:0" allowfullscreen></iframe>
          <p>比赛地点：上海市逸仙路1328号 新业坊·源创全球科创示范区</p>
          <br/>
          <p>线路1:上海虹桥国际机场 -> 地铁2号线 → 地铁3号线 ->场馆</p>
          <br/>
          <p>线路2:上海浦东国际机场 -> 地铁2号线 → 地铁4号线 → 地铁3号线  -> 场馆</p>
        </div>
        <div class="map mp2">
          <iframe src="http://www.google.cn/maps/embed?pb=!1m18!1m12!1m3!1d3408.462568901253!2d121.48284531514557!3d31.318595981436744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35b2724e8505a4e9%3A0x26fa00917fbd1e09!2s1328+Yixian+Rd%2C+Wu+Jiao+Chang%2C+Baoshan+Qu%2C+Shanghai+Shi%2C+200065!5e0!3m2!1sen!2scn!4v1566195693900!5m2!1sen!2scn" width="580" height="440" frameborder="0" style="border:0" allowfullscreen></iframe>
          <p> No. 1328, Yixian Road, Shanghai, Xinye Fang·Yuanchuang Global Science and Technology Demonstration Zone</p>
          <br/>
          <p>Shanghai Hongqiao International Airport -> Metro Line 2 → Metro Line 3 -> Venue</p>
          <br/>
          <p>Shanghai Pudong International Airport -> Metro Line 2 →  Metro Line 4 →  Metro Line 3 -> Venue</p>
        </div>
      </div>
      <div style="color: #ffffff;margin-bottom: 40px">
        <div class="title"><img src="../assets/img/title.png" alt=""/>酒店推荐/Recommended hotels</div>
        <p>酒店推荐：上海虹口大柏树亚朵酒店，地址：上海曲阳路1000号。距离活动场地约3公里，电话021-55979999全季酒店(上海新江湾城殷高路店) 上海市宝山区高境镇殷高路65号 (021)55895799</p>
        <br/>
        <p>Recommended hotels：Atour Hotel (Shanghai Hongkou Dabaishu) reserve：400 862 8088 (CouponCode:74287) Business zone: Wujiaochang Business District (江湾/五角场商业区)Area: hongkouqu (虹口区)Address: QuYang road 1000, Hongkou District, Shanghai, China</p>
      </div>


    </div>

    <div class="roleBox" v-if="maskBl">
      <div class="rolebg" v-if="imgList">
        <p class="gb" @click="imgFun()"></p>
        <ul>
          <li v-for="(key,index) in imgList" :class="{on:key.onBl}" @click="imgListFun(index,key)">
            <img v-if="key.onBl==false" :src="key.img" alt=""/>
            <img v-else :src="key.img2" alt=""/>
            <p>{{key.name}}</p>
          </li>
        </ul>
      </div>
      <div class="roleBtn" @click="roleBtn()"></div>
    </div>
    <mybottom></mybottom>
  </div>
</template>

<script>
  import nation from '../assets/js/nation.json'
  import myhead from './Head.vue'
  import mybottom from './Bottom.vue'
  import img1 from '../assets/img/1.png'
  import img2 from '../assets/img/2.png'
  import img3 from '../assets/img/3.png'
  import img4 from '../assets/img/5.png'
  import img5 from '../assets/img/4.png'
  import img6 from '../assets/img/6.png'
  import img7 from '../assets/img/7.png'
  import img8 from '../assets/img/8.png'
  import img9 from '../assets/img/9.png'
  import img10 from '../assets/img/10.png'
  import img11 from '../assets/img/11.png'
  import img12 from '../assets/img/12.png'
  import img13 from '../assets/img/13.png'
  import img14 from '../assets/img/23.png'
  import img15 from '../assets/img/15.png'
  import img16 from '../assets/img/16.png'
  import img17 from '../assets/img/17.png'
  import img18 from '../assets/img/18.png'
  import img19 from '../assets/img/19.png'
  import img20 from '../assets/img/20.png'
  import img21 from '../assets/img/21.png'
  import img22 from '../assets/img/22.png'
  import img23 from '../assets/img/14.png'
  import img24 from '../assets/img/24.png'
  import img25 from '../assets/img/25.png'
  import img26 from '../assets/img/30.png'
  import img27 from '../assets/img/27.png'
  import img28 from '../assets/img/28.png'
  import img29 from '../assets/img/29.png'
  import img30 from '../assets/img/26.png'
  import img31 from '../assets/img/31.png'
  import img32 from '../assets/img/32.jpg'
  import img33 from '../assets/img/33.jpg'
  import img34 from '../assets/img/34.jpg'
  import img35 from '../assets/img/35.jpg'

  import img1_ from '../assets/img/1_.jpg'
  import img2_ from '../assets/img/2_.jpg'
  import img3_ from '../assets/img/3_.jpg'
  import img4_ from '../assets/img/4_.jpg'
  import img5_ from '../assets/img/5_.jpg'
  import img6_ from '../assets/img/6_.jpg'
  import img7_ from '../assets/img/7_.jpg'
  import img8_ from '../assets/img/8_.jpg'
  import img9_ from '../assets/img/9_.jpg'
  import img10_ from '../assets/img/10_.jpg'
  import img11_ from '../assets/img/11_.jpg'
  import img12_ from '../assets/img/12_.jpg'

  import img13_ from '../assets/img/13_.jpg'
  import img14_ from '../assets/img/23_.jpg'
  import img15_ from '../assets/img/22_.jpg'
  import img16_ from '../assets/img/21_.jpg'
  import img17_ from '../assets/img/20_.jpg'
  import img18_ from '../assets/img/19_.jpg'
  import img19_ from '../assets/img/18_.jpg'
  import img20_ from '../assets/img/17_.jpg'
  import img21_ from '../assets/img/16_.jpg'
  import img22_ from '../assets/img/15_.jpg'
  import img23_ from '../assets/img/14_.jpg'
  import img24_ from '../assets/img/24_.jpg'

  import img25_ from '../assets/img/25_.jpg'
  import img26_ from '../assets/img/30_.jpg'
  import img27_ from '../assets/img/29_.jpg'
  import img28_ from '../assets/img/28_.jpg'
  import img29_ from '../assets/img/27_.jpg'
  import img30_ from '../assets/img/26_.jpg'
  import img31_ from '../assets/img/31_.jpg'
  import img32_ from '../assets/img/32_.jpg'
  import img33_ from '../assets/img/33_.jpg'
  import img34_ from '../assets/img/34_.jpg'
  import img35_ from '../assets/img/35_.jpg'

  export default {
    name: 'Rules',
    components: {
      myhead,
      mybottom
    },
    data () {
      return {
        fimg:"",
        name:"",
        phone:"",
        identityCard:"",
        SteamId:"",
        email:"",
        QQ:"",
        nationData:"",
        nationID:"",
        role1:"",
        role2:"",
        role3:"",
        imgList:[
          {id:1,onBl:false,img2:img1_,img:img1,name:"ABIGAIL"},
          {id:2,onBl:false,img2:img2_,img:img2,name:"ALEX"},
          {id:3,onBl:false,img2:img3_,img:img3,name:"BALROG"},
          {id:4,onBl:false,img2:img4_,img:img4,name:"BIRDIE"},
          {id:5,onBl:false,img2:img5_,img:img5,name:"M.BISON"},
          {id:6,onBl:false,img2:img6_,img:img6,name:"BLANKE"},
          {id:7,onBl:false,img2:img7_,img:img7,name:"CAMMY"},
          {id:8,onBl:false,img2:img8_,img:img8,name:"CHUN-LI"},
          {id:9,onBl:false,img2:img9_,img:img9,name:"DHALSIM"},
          {id:10,onBl:false,img2:img10_,img:img10,name:"ED"},
          {id:11,onBl:false,img2:img11_,img:img11,name:"F.A.N.G"},
          {id:12,onBl:false,img2:img12_,img:img12,name:"AKUMA"},
          {id:13,onBl:false,img2:img13_,img:img13,name:"IBUKI"},
          {id:14,onBl:false,img2:img14_,img:img14,name:"RASHID"},
          {id:15,onBl:false,img2:img15_,img:img22,name:"NECALLI"},
          {id:16,onBl:false,img2:img16_,img:img21,name:"NASH"},
          {id:17,onBl:false,img2:img17_,img:img20,name:"R.MIKA"},
          {id:18,onBl:false,img2:img18_,img:img19,name:"MENAT"},
          {id:19,onBl:false,img2:img19_,img:img18,name:"LAURA"},
          {id:20,onBl:false,img2:img20_,img:img17,name:"KOLIN"},
          {id:21,onBl:false,img2:img21_,img:img16,name:"KEN"},
          {id:22,onBl:false,img2:img22_,img:img15,name:"KARIN"},
          {id:23,onBl:false,img2:img23_,img:img23,name:"JURI"},
          {id:24,onBl:false,img2:img24_,img:img24,name:"RYU"},
          {id:25,onBl:false,img2:img25_,img:img25,name:"SAKURA"},
          {id:26,onBl:false,img2:img26_,img:img26,name:"URIEN"},
          {id:27,onBl:false,img2:img27_,img:img29,name:"GUILE"},
          {id:28,onBl:false,img2:img28_,img:img28,name:"ZEKU"},
          {id:29,onBl:false,img2:img29_,img:img27,name:"ZANGIEF"},
          {id:30,onBl:false,img2:img30_,img:img30,name:"VEGA"},
          {id:31,onBl:false,img2:img31_,img:img31,name:"FALKE"},
          {id:32,onBl:false,img2:img32_,img:img32,name:"SAGAT"},
          {id:33,onBl:false,img2:img33_,img:img33,name:"CODY"},
          {id:34,onBl:false,img2:img34_,img:img34,name:"KAGE"},
          {id:35,onBl:false,img2:img35_,img:img35,name:"G"},
        ],
        imgArr:[],
        maskBl:false,
        markerArr : [{title:"比赛场地",content:"上海市逸仙路1328号&nbsp;新业坊·源创全球科创示范区",point:"121.48998|31.323858",isOpen:1,icon:{w:23,h:25,l:46,t:21,x:9,lb:12}}],
      }
    },

    computed:{

    },
    mounted(){
      this.nationData=nation
      this.nationID=nation[0].id
    },
    methods:{
      //      头像
      chang(){
        console.log("9")
        if(this.$refs.file.files[0]){
          let _this=this;
          var fileObj = _this.$refs.file
          var windowURL = window.URL || window.webkitURL;
          var dataURL;
          if(fileObj && fileObj.files && fileObj.files[0]){
            dataURL = windowURL.createObjectURL(fileObj.files[0]);
            _this.fimg=dataURL
          }else{
            _this.fimg=fileObj.value;
          }
        }
      },
      nationFun(id){
        this.nationID=id;
      },
      imgFun(){
        if(this.maskBl==true){
          this.maskBl=false;
        }else{
          this.maskBl=true;
        }
      },
      imgListFun(index){
        let _this=this;
        if( _this.imgList[index].onBl==true){
          _this.imgList[index].onBl=false;
          _this.imgArr.pop(0)
        }else{
          if(_this.imgArr.length!==3){
            _this.imgList[index].onBl=true;
            _this.imgArr.push(_this.imgList[index].onBl.name)
          }else{
            alert("最多选择三个角色")
          }
        }
      },
      roleBtn(){
        let arr=[]
        for(var i=0;i<this.imgList.length;i++){
          if(this.imgList[i].onBl==true){
            arr.push(this.imgList[i])
          }
        }
        if(arr.length==3){
          this.role1=arr[0]
          this.role2=arr[1]
          this.role3=arr[2]
          console.log("完成")
          this.maskBl=false;
        }else{
          alert("请选择三个角色")
        }
      },
      urlFun(url){
        this.$router.push({path:url})
      },
      subbtnUp(){
        let _this=this;
        let regex = /^[1][3,4,5,8][0-9]{9}$/;
        let regex2 = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g;
        if(_this.name==""){ return alert("请输入姓名")}
        if(_this.phone.length>11||_this.phone==""){ return alert("请正确手机号")}
        if(_this.identityCard==""){ return alert("请输入证件号")}
        if(_this.SteamId==""){ return alert("请输入SteamID")}
        if(!regex2.test(_this.email)){ return alert("请输入正确email")}
        if(_this.QQ==""){ return alert("请输入qq")}
//        if(!_this.$refs.file.files[0]){ return alert("请选择照片")}
        if(!_this.role1.id&&!_this.role2&&!_this.role3){return alert("请选择三个角色")}
        let formd=new FormData()
        console.log(_this.nationID)
        formd.append("realName",_this.name)
        formd.append("mobile",_this.phone)
        formd.append("idCard",_this.identityCard)
        formd.append("nalitionality",_this.nationID)
        formd.append("gameName",_this.SteamId)
        formd.append("eMail",_this.email)
        formd.append("qqCode",_this.QQ)
        formd.append("userAvatar",_this.$refs.file.files[0])
        formd.append("gameRole[0]",_this.role1.id)
        formd.append("gameRole[1]",_this.role2.id)
        formd.append("gameRole[2]",_this.role3.id)
        formd.append("matchId",139)
        this.$axios.post("http://admin.matchon.net/client/seriesRegisterSignup",formd).then((data) => {
          if(data.data.code==200){
            alert("报名成功")
          }else{
            alert(data.data.description)
          }
          if(data.data.code==500){
            alert("服务器繁忙请稍后再报名")
          }
        });
      },


    },
    filters:{

    }
  }
</script>


<!--Content-Disposition: form-data; name="realName"安云鹏-->

<!--Content-Disposition: form-data; name="mobile"18210522994-->

<!--Content-Disposition: form-data; name="idCard"2312221994-->

<!--Content-Disposition: form-data; name="nalitionality"1-->

<!--Content-Disposition: form-data; name="gameName"yunpengAn-->

<!--Content-Disposition: form-data; name="eMail"18210522994@163.com-->

<!--Content-Disposition: form-data; name="qqCode"528875857-->

<!--Content-Disposition: form-data; name="userAvatar"; filename="1 PPL-首页.jpg"Content-Type: image/jpeg-->
<!--Content-Disposition: form-data; name="gameRole[0]"1-->

<!--Content-Disposition: form-data; name="gameRole[1]"2-->

<!--Content-Disposition: form-data; name="gameRole[2]"3-->

<!--Content-Disposition: form-data; name="matchId"139-->






// WEBPACK FOOTER //
// src/components/signUp.vue